export default __webpack_public_path__ + "static/media/Forest-Layer-3.bc4d5228.png";